import React, {useState} from 'react';
import './testimonial.scss';
import {Button} from "../../../../components";
import {ReactComponent as TESTIMONIAL_ARROW} from 'assets/icons/testimonial_arrow.svg';
import {ReactComponent as RATINGS} from 'assets/icons/ratings.svg';
import IMAGE_1 from "../../../../assets/home-page/join_us_1.png";
import IMAGE_2 from "../../../../assets/home-page/join_us_2.png";
import IMAGE_3 from "../../../../assets/home-page/join_us_3.png";
import IMAGE_4 from "../../../../assets/home-page/join_us_4.png";
import IMAGE_5 from "../../../../assets/home-page/join_us_5.png";
import {useNavigate} from "react-router-dom";
import {useMediaQuery} from "react-responsive";

interface TestimonyTypes {
    name: string,
    title: string,
    description: string
}

const testimonyData: TestimonyTypes[] = [
    {
        name: "John Johnson",
        title: "CEO, Own Company",
        description: "Really enjoyed working with the SBAJ to plan and get my business started."
    },
    {
        name: "Kimberly Clarke",
        title: "Project Manager, Layers",
        description: "Great Services. I really enjoyed working with SBAJ to get my business off the ground."
    },
    {
        name: "Shaneel Peterson",
        title: "CEO, SS Creatives",
        description: "Never have i experienced such growth in such short period. The SBAJ really helped my business to grow."
    },
]

const Testimonials = () => {
    const [counter, setCounter] = useState(0)
    const [testimonies] = useState<TestimonyTypes[]>(testimonyData);
    const navigate = useNavigate();
    const isMobile = useMediaQuery({
        query: '(min-width: 500px)'
    })
    const nextTestimony = () => {
        if (counter < testimonies.length - 1) {
            setCounter((prev) => prev + 1)
        } else {
            setCounter(0);
        }
    }
    const prevTestimony = () => {

        if (counter === 0) {
            setCounter(testimonies.length - 1)
        } else {
            setCounter((prev) => prev - 1);
        }
    }
    return (
        <div className={'testimonials'} id={'business_testimonials'}>
            <div className="testimonials_wrapper max">
                <div className="testimonials_wrapper_left">
                    <div className="testimonials_wrapper_left_top">
                        <div className="testimonials_wrapper_left_top_user">
                            <div className="testimonials_wrapper_left_top_user_avatar">
                            </div>
                            <div className="testimonials_wrapper_left_top_user_info">
                                <span id={'name'}>{testimonies[counter].name}</span>
                                <span>{testimonies[counter].title}</span>
                            </div>
                        </div>
                        {isMobile && <div className="testimonials_wrapper_left_top_nav">
                            <TESTIMONIAL_ARROW className={'testimonials_prev_arrow '} onClick={prevTestimony}/>
                            <TESTIMONIAL_ARROW className={'testimonials_next_arrow '} onClick={nextTestimony}/>
                        </div>}
                    </div>
                    <div className="testimonials_wrapper_left_middle">
                        <RATINGS/>
                        <h1 id={'testimonial-description'}>{testimonies[counter].description}</h1>
                    </div>
                    <div className="testimonials_wrapper_left_bottom">
                        {isMobile && <p>Become a member today. Its simple, safe and affordable. </p>}
                        {isMobile ? <div className="testimonials_wrapper_left_bottom_cta">
                                <Button text={'Get Started Now'} type={'primary'} onclick={() => navigate('/registration')}/>
                                {/*<Button text={'Contact Us'} type={'secondary'}/>*/}
                            </div>

                            : <div className="testimonials_wrapper_left_top_nav">
                                <TESTIMONIAL_ARROW className={'testimonials_prev_arrow '} onClick={prevTestimony}/>
                                <TESTIMONIAL_ARROW className={'testimonials_next_arrow '} onClick={nextTestimony}/>
                            </div>}
                    </div>
                </div>
                <div className="testimonials_wrapper_right">
                    <div className="testimonials_wrapper_right_container">
                        <img className="testimonials_wrapper_right_container_image_1" src={IMAGE_1} alt=""/>
                        <img className="testimonials_wrapper_right_container_image_2" src={IMAGE_2} alt=""/>
                        <img className="testimonials_wrapper_right_container_image_3" src={IMAGE_3} alt=""/>
                        <img className="testimonials_wrapper_right_container_image_4" src={IMAGE_4} alt=""/>
                        <img className="testimonials_wrapper_right_container_image_5" src={IMAGE_5} alt=""/>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Testimonials;
